import { Routes, Route, Navigate } from 'react-router-dom'
import Home from 'pages/Home/Home'
import SignIn from 'pages/SignIn/SignIn'
import NewApplication from 'pages/NewApplication/NewApplication'
import Client from 'pages/Client/Client'
import Collateral from 'pages/Collateral/Collateral'
import Application from 'pages/Application/Application'
import Contract from 'pages/Contract/Contract'
import { useRoutes } from './lib/hooks'
import { useAuthStore } from './context/AuthStore'
import PrivateRoute from './routes/PrivateRoute'

function App() {
  const { authStore } = useAuthStore()
  const { lastVisit } = useRoutes()

  return (
    <Routes>
      <Route path="/home" element={<PrivateRoute element={<Home />} />} />
      <Route
        path="/new-application/:id?"
        element={<PrivateRoute element={<NewApplication />} pageType="new-application" />}
      />
      <Route path="/application/:id?" element={<PrivateRoute element={<Application />} pageType="application" />} />
      <Route path="/contract/:id?" element={<PrivateRoute element={<Contract />} pageType="contract" />} />
      <Route path="/client/:id?" element={<PrivateRoute element={<Client />} pageType="client" />} />
      <Route path="/collateral/:id?" element={<PrivateRoute element={<Collateral />} pageType="collateral" />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route
        path="*"
        element={
          <Navigate
            to={authStore.isLoggedIn ? (lastVisit && lastVisit !== '/sign-in' ? lastVisit : '/home') : '/sign-in'}
          />
        }
      />
    </Routes>
  )
}

export default App
